export default function OdemeHatasi() {
  return (
    <div style={{ minHeight: '100vh', background: '#080808', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Syne', sans-serif", padding: 24 }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&display=swap');`}</style>
      <div style={{ textAlign: 'center', maxWidth: 480 }}>
        <div style={{ width: 80, height: 80, borderRadius: '50%', background: 'rgba(239,68,68,0.1)', border: '2px solid rgba(239,68,68,0.3)', margin: '0 auto 24px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 36 }}>❌</div>
        <h1 style={{ fontSize: 32, fontWeight: 800, color: 'white', marginBottom: 12 }}>Ödeme Başarısız</h1>
        <p style={{ fontSize: 16, color: '#666', marginBottom: 32, lineHeight: 1.7 }}>Ödeme işlemi tamamlanamadı. Tekrar denemek için aşağıdaki butona tıklayın.</p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <a href="/register" style={{ background: 'linear-gradient(135deg, #f97316, #ef4444)', color: 'white', padding: '14px 28px', borderRadius: 10, textDecoration: 'none', fontWeight: 700, fontSize: 15 }}>
            Tekrar Dene →
          </a>
          <a href="https://wa.me/905324490381" target="_blank" rel="noreferrer" style={{ background: 'transparent', color: '#666', border: '1px solid #222', padding: '14px 28px', borderRadius: 10, textDecoration: 'none', fontWeight: 600, fontSize: 15 }}>
            💬 Destek Al
          </a>
        </div>
      </div>
    </div>
  );
}